import { NgModule } from '@angular/core';
import {
  PdfExportOptionsComponent
} from '@app/pcs/shared/export-options/pdf-export-options/components/pdf-export-options.component';
import {
  PdfExportOptionsFormComponent
} from '@app/pcs/shared/export-options/pdf-export-options/components/pdf-export-options-form.component';
import {
  PopOverExportOptionsModule
} from '@app/pcs/shared/export-options/pop-over-export-options/components/pop-over-export-options.module';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    SharedModule,
    PopOverExportOptionsModule
  ],
  declarations: [
    PdfExportOptionsComponent,
    PdfExportOptionsFormComponent
  ],
  exports: [
    PdfExportOptionsComponent
  ]
})
export class PdfExportOptionsModule {

}
